import React, { PropTypes, Component } from 'react'
import { debounce } from 'lodash'
import { Link } from 'react-router'
import cx from 'classnames'

import './Reschedule.scss'
import RescheduleNavBar from './components/RescheduleNavBar'
import RescheduleAliadaProfile from 'components/RescheduleAliadaProfile'
import RescheduleDurationField from 'components/RescheduleDurationField'
import AvailabilityCalendar from 'components/AvailabilityCalendar'
import AvailabilityLoader from 'components/AvailabilityLoader'

import * as paths from 'utils/paths'

class Reschedule extends Component {
  constructor (props) {
    super(props)

    this.state = {
      selectedDate: undefined,
      serviceDuration: this.props.service && this.props.service.estimatedHours
    }

    this.onDateSelected = this.onDateSelected.bind(this)
    this.debounceWait = 400
    this.onDurationChanged = debounce(this.onDurationChanged.bind(this), this.debounceWait)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount () {
    this.fetchService()
    this.fetchAliada()
  }

  componentWillReceiveProps (nextProps) {
    this.setServiceDurationIfUndefined(nextProps)
  }

  setServiceDurationIfUndefined ({ service }) {
    if (!service) {
      return
    }

    const { estimatedHours } = service
    const serviceDurationIsUndefined = !this.state.serviceDuration
    if (serviceDurationIsUndefined) {
      this.setState({
        serviceDuration: parseFloat(estimatedHours)
      })
    }
  }

  componentDidUpdate (prevProps, prevState) {
    this.fetchAliadaIfUndefined()
    this.fetchAliadaIfDurationChanged(prevProps, prevState)
  }

  fetchAliadaIfUndefined () {
    const aliadaIsUndefined = !this.props.aliada
    if (aliadaIsUndefined) {
      this.fetchAliada()
    }
  }

  fetchAliadaIfDurationChanged (prevProps, prevState) {
    const serviceDurationChanged = prevState.serviceDuration !== this.state.serviceDuration
    if (serviceDurationChanged) {
      this.fetchAliada()
    }
  }

  fetchService () {
    const { serviceId } = this.props
    this.props.fetchService(serviceId)
  }

  fetchAliada () {
    const {
      aliadaId,
      service,
      fetchAliada,
      params: {
        serviceId
      }
    } = this.props
    const serviceTypeId = service && service.serviceTypeId
    const estimatedHours = this.state.serviceDuration
    const coordinates = service && service.address.location

    if (aliadaId && estimatedHours) {
      fetchAliada(aliadaId, {
        estimatedHours,
        serviceTypeId,
        coordinates,
        serviceId
      })
    }
  }

  onDateSelected (date) {
    this.setState({ selectedDate: date })
  }

  onDurationChanged (duration) {
    this.setState({ serviceDuration: duration })
  }

  onSubmit (e) {
    const shouldPreventDefault = !this.state.selectedDate
    if (shouldPreventDefault) {
      e.preventDefault()
    }
  }

  isLoading () {
    const { service, aliada } = this.props
    return !service || !(aliada && aliada.availability)
  }

  render () {
    const {
      selectedDate,
      serviceDuration
    } = this.state

    const {
      serviceId,
      aliada,
      fetchingAliada,
      params: {
        userId
      }
    } = this.props

    const loading = this.isLoading()
    const submitButtonIsDisabled = !selectedDate

    const confirmButtonClassName = cx(
      'Reschedule-reserveButton',
      'btn btn-primary btn-block btn-lg',
      {
        disabled: submitButtonIsDisabled
      }
    )

    const confirmQueryobject = {
      aliadaId: aliada && aliada.id,
      estimatedHours: serviceDuration,
      datetime: selectedDate && selectedDate.format()
    }

    const confirmUrl = paths.rescheduleServiceConfirm(userId, serviceId, confirmQueryobject)

    return (
      <div className='Reschedule navbar-screen'>
        <RescheduleNavBar aliada={aliada} />
        {!loading &&
          <div className='Reschedule-content navbar-screen-content'>
            <div className='navbar-screen-container'>
              <div className='Reschedule-header'>
                <RescheduleAliadaProfile
                  aliada={aliada}
                  serviceDuration={parseFloat(serviceDuration)}
                  />
                <RescheduleDurationField
                  initialValue={parseFloat(serviceDuration)}
                  onChange={this.onDurationChanged}
                  />
              </div>

              <div className='Reschedule-availability'>
                <h3>Elige que día y hora te gustaría que {aliada.firstName} vaya a tu domicilio</h3>

                {fetchingAliada
                  ? <AvailabilityLoader />
                  : <AvailabilityCalendar
                    availability={aliada.availability}
                    onChange={this.onDateSelected}
                    showUnavailableDays={false}
                    />
                }
              </div>

              <div className='Reschedule-reserve'>
                <Link
                  style={{whiteSpace: 'normal'}}
                  className={confirmButtonClassName}
                  to={confirmUrl}
                  onClick={this.onSubmit}
                  >
                  Reagenda tu servicio con {aliada.firstName}
                </Link>
              </div>
            </div>
          </div>
        }
      </div>
    )
  }
}

Reschedule.displayName = 'Reschedule'
Reschedule.propTypes = {
  serviceId: PropTypes.number.isRequired,
  service: PropTypes.object,
  aliadaId: PropTypes.number,
  aliada: PropTypes.object,
  fetchingAliada: PropTypes.bool.isRequired,
  updatingService: PropTypes.bool.isRequired,
  fetchAliada: PropTypes.func.isRequired,
  fetchService: PropTypes.func.isRequired,
  updateService: PropTypes.func.isRequired,
  params: PropTypes.shape({
    userId: PropTypes.string.isRequired
  }).isRequired
}

export default Reschedule



// WEBPACK FOOTER //
// ./src/screens/App/screens/Services/screens/Reschedule/Reschedule.js